import * as React from "react";
import type { SVGProps } from "react";
const SvgTrainFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#train-front_svg__a)">
      <path d="M17 18H7c-1.65 0-3-1.35-3-3V6c0-2.21 1.79-4 4-4h8c2.21 0 4 1.79 4 4v9c0 1.65-1.35 3-3 3M8 4c-1.1 0-2 .9-2 2v9c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6c0-1.1-.9-2-2-2z" />
      <path d="M12.1 12H12c-3.47 0-5.55-.51-7.29-1.04a1 1 0 0 1-.66-1.25.99.99 0 0 1 1.25-.66c1.59.49 3.5.95 6.71.96h.1c3.23 0 5.04-.47 6.61-.96a.997.997 0 0 1 1.25.66 1 1 0 0 1-.66 1.25c-1.72.53-3.68 1.04-7.19 1.04zM9 15H8c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1M16 15h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M12 12c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1M6 22a1.01 1.01 0 0 1-.9-1.45l2-4c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-2 4c-.18.35-.53.55-.9.55zM18 22c-.37 0-.72-.2-.9-.55l-2-4a.993.993 0 0 1 .45-1.34.99.99 0 0 1 1.34.45l2 4c.25.49.05 1.09-.45 1.34-.14.07-.3.11-.45.11z" />
      <path d="M17 21H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="train-front_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTrainFront;
